import { Star, Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Priya Sharma',
      project: 'Zebra Blinds Installation',
      rating: 5,
      text: 'Absolutely stunning work! The zebra blinds transformed our living room. The team was professional, punctual, and the installation was flawless. Highly recommend SBJ Glassworks!',
      location: 'Delhi'
    },
    {
      id: 2,
      name: 'Rajesh Kumar',
      project: 'Korean Wallpaper & Glass Films',
      rating: 5,
      text: 'We got Korean wallpaper for our bedroom and frosted glass film for the bathroom. The quality is exceptional and the attention to detail during installation was impressive. Worth every penny!',
      location: 'Gurgaon'
    },
    {
      id: 3,
      name: 'Anjali Mehta',
      project: 'Office Vertical Blinds',
      rating: 5,
      text: 'SBJ Glassworks handled our entire office blind installation. They were efficient, professional, and the results exceeded our expectations. Our office looks modern and elegant now.',
      location: 'Noida'
    },
    {
      id: 4,
      name: 'Vikram Singh',
      project: 'Custom Mandir Blinds',
      rating: 5,
      text: 'They created beautiful customized blinds for our home mandir. The team understood our requirements perfectly and delivered exactly what we envisioned. Excellent craftsmanship!',
      location: 'Faridabad'
    }
  ];

  const StarRating = ({ rating }) => {
    return (
      <div className="flex gap-1">
        {[...Array(5)].map((_, idx) => (
          <Star
            key={idx}
            className={`w-5 h-5 ${
              idx < rating ? 'fill-amber-400 text-amber-400' : 'text-slate-600'
            }`}
          />
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-slate-800/50 to-slate-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-amber-300 to-amber-500 bg-clip-text text-transparent">
            What Our Clients Say
          </h3>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Don't just take our word for it - hear from our satisfied customers
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, idx) => (
            <div
              key={testimonial.id}
              className="group relative bg-gradient-to-br from-slate-800 to-slate-900 p-8 rounded-2xl border border-slate-700 hover:border-amber-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-amber-500/20 hover:-translate-y-1"
              style={{ animationDelay: `${idx * 100}ms` }}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 opacity-20 group-hover:opacity-30 transition-opacity">
                <Quote className="w-16 h-16 text-amber-400" />
              </div>

              {/* Content */}
              <div className="relative z-10">
                {/* Rating */}
                <div className="mb-4">
                  <StarRating rating={testimonial.rating} />
                </div>

                {/* Testimonial Text */}
                <p className="text-slate-300 text-lg leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </p>

                {/* Customer Info */}
                <div className="border-t border-slate-700 pt-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <h4 className="font-bold text-white text-lg">{testimonial.name}</h4>
                      <p className="text-amber-400 text-sm">{testimonial.project}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-slate-400 text-sm">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Decorative gradient */}
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-amber-600 opacity-0 group-hover:opacity-100 transition-opacity rounded-b-2xl"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-slate-300 text-lg mb-6">
            Ready to transform your space?
          </p>
          <a
            href="#contact"
            className="inline-block bg-gradient-to-r from-amber-500 to-amber-600 px-8 py-3 rounded-full text-lg font-semibold hover:shadow-xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105"
          >
            Get Your Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
